module.exports = __webpack_public_path__ + "GRANULO_HOVER_PE@2x.jpg?bc8ff7d26bb47f6cf3bdfae4503be71e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GRANULO_HOVER_PE@2x.jpg
// module id = 92
// module chunks = 0